<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';

  interface Props {
    label?: string;
    onclick?: (e: MouseEvent) => void;
  }

  let { label = '', onclick }: Props = $props();
</script>

<button data-cy="needs-review-alert-tag" class="comp-alert-tag" {onclick}>
  <div class="icon">
    <Icon value="icon-alert-triangle" />
  </div>
  <div data-cy="needs-review-alert-label" class="text">{label}</div>
</button>

<style>
  .comp-alert-tag {
    height: 32px;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: var(--black);
    display: inline-flex;
    align-items: center;
    background-color: var(--yellow);
    padding: 0 16px;
    border-radius: 4px;
  }
  .comp-alert-tag:hover {
    background-color: var(--yellow-hover);
  }
  .comp-alert-tag .icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .comp-alert-tag .icon {
    margin-right: 8px;
  }
</style>
